import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { EditableList, ReadingListDetails } from '®shared/reading-list';

import { getListStatus } from '../list-status/list-status-utils';
import { ListStatus } from '../list-status/list-status.component';

@Component({
  selector: 'rl-list-status-description',
  templateUrl: './list-status-description.component.html',
})
export class ListStatusDescriptionComponent implements OnInit, OnChanges {
  @Input() list: ReadingListDetails;
  @Input() editableList: EditableList;

  listStatus: string;
  listStatusConstants = ListStatus;

  ngOnInit(): void {
    this.listStatus = getListStatus(this.list, this.editableList);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.editableList) {
      this.listStatus = getListStatus(this.list, this.editableList);
    }
  }
}
